(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-common-wager/assets/javascripts/models/bet.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-common-wager/assets/javascripts/models/bet.js');

'use strict';

svs.numbergames.mybets_common_wager.models.Bet = svs.numbergames.core.NumbergamesModel.extend({
  defaults() {
    return {
      boards: new svs.numbergames.mybets_common_wager.collections.Boards(),
      productId: '',
      betAmountSalesGroup1: undefined,
      betAmountSalesGroup2: undefined,
      drawBetAmount: undefined,
      rowPriceMulti: undefined
    };
  },
  parse(attrs) {
    svs.numbergames.mybets_common_wager.logger.debug('models.Bet parse', attrs);
    if (attrs.boards) {
      this.get('boards').add(attrs.boards, {
        productId: attrs.productId,
        parse: true
      });
    }
    return {
      productId: attrs.productId,
      betAmountSalesGroup1: attrs.betAmountSalesGroup1,
      betAmountSalesGroup2: attrs.betAmountSalesGroup2,
      drawBetAmount: attrs.drawBetAmount,
      rowPriceMulti: attrs.rowPriceMulti
    };
  }
});

 })(window);